import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {StyledButton} from '../../../styled-button'
import {classes} from './empty-state.st.css'
import {EmptyStateProps} from './index'

export const EmptyState = ({onButtonClick}: EmptyStateProps) => {
  const {t} = useTranslation()

  React.useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.EMPTY_STATE_TITLE)})
  }, [])

  return (
    <div className={classes.container}>
      <Text tagName="h2" className={classes.title} data-hook={DH.EMPTY_STATE_TITLE}>
        {t('seating_accessibilityMode_emptyState_title')}
      </Text>
      <Text tagName="p" className={classes.description}>
        {t('seating_accessibilityMode_emptyState_description')}
      </Text>
      <StyledButton dataHook={DH.RESET_FILTERS} onClick={onButtonClick} secondary={true} fullWidth={false}>
        {t('seating_accessibilityMode_emptyState_action')}
      </StyledButton>
    </div>
  )
}
